import { footerData } from '@/mocks/home';

export default function Footer() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-background-900 text-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <span className="font-heading text-2xl text-primary-400 tracking-wide">
              51影院
            </span>
            <p className="mt-4 text-sm text-background-300 leading-relaxed max-w-md">
              {footerData.description}
            </p>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-sm font-semibold text-background-100 mb-4">
              <a href="#" className="text-background-100 no-underline">快速导航</a>
            </h4>
            <div className="grid grid-cols-2 gap-2">
              {footerData.quickLinks.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={(e) => handleNavClick(e, link.href)}
                  className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer no-underline"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div className="md:col-span-4">
            <h4 className="text-sm font-semibold text-background-100 mb-4">
              <a href="#" className="text-background-100 no-underline">合作伙伴</a>
            </h4>
            <p className="text-sm text-background-400">
              诚邀优质影视站点合作，共同为广大观众提供更丰富的电视剧大全、电影大全和综艺节目资源。
            </p>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-700/50">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500">{footerData.copyright}</p>
            <div className="flex items-center gap-4">
              <span className="text-xs text-background-500">友情链接：久久影院 · 悠久影院 · 九九影院 · 55影院</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}